import { render, staticRenderFns } from "./affiliates.vue?vue&type=template&id=19712c94"
import script from "./affiliates.vue?vue&type=script&lang=js"
export * from "./affiliates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports